// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import CollapsableTools from '../../collapsableTools/CollapsableTools';
import SubToolList from '../SubToolList';
import TextStyleRichTextToolContainer from './textStylesTool/TextStyleRichTextToolContainer';

// Constants
import { RICH_TEXT_TOOLS_CONFIG, TOOL_KEYS } from './richTextToolConstants';

const TABLE_EDITOR_TOOLS_CONFIG = {
    default: RICH_TEXT_TOOLS_CONFIG.default,
    [TOOL_KEYS.BOLD]: RICH_TEXT_TOOLS_CONFIG[TOOL_KEYS.BOLD],
    [TOOL_KEYS.ITALIC]: RICH_TEXT_TOOLS_CONFIG[TOOL_KEYS.ITALIC],
    [TOOL_KEYS.STRIKETHROUGH]: RICH_TEXT_TOOLS_CONFIG[TOOL_KEYS.STRIKETHROUGH],
};

const TABLE_EDITOR_TOOLS_SELECTION = [TOOL_KEYS.BOLD, TOOL_KEYS.ITALIC, TOOL_KEYS.STRIKETHROUGH];

const TableEditorToolList = (props) => {
    const { gridSizeName, availableHeight, unavailableHeight } = props;

    return (
        <div data-table-util={true}>
            <SubToolList {...props} className="TableEditorToolList">
                <TextStyleRichTextToolContainer {...props} showBlockStyleTools={false} />
                <CollapsableTools
                    {...props}
                    toolsId="text"
                    toolsConfig={TABLE_EDITOR_TOOLS_CONFIG}
                    availableTools={TABLE_EDITOR_TOOLS_SELECTION}
                    availableHeight={availableHeight}
                    gridSizeName={gridSizeName}
                    unavailableHeight={unavailableHeight}
                />
            </SubToolList>
        </div>
    );
};

TableEditorToolList.propTypes = {
    editorKey: PropTypes.string,
    gridSizeName: PropTypes.string,
    availableHeight: PropTypes.number,
    unavailableHeight: PropTypes.number,
    hasEditorSelection: PropTypes.bool,
};

export default TableEditorToolList;
